import styled from 'styled-components';

import { DutchiePayLogo } from 'src/assets/dutchie-pay-logo';
import { PayByBankLogo as _PayByBankLogo } from 'src/assets/pay-by-bank-logo';

export const LogosLockup = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 12px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-bottom: 18px;
  }
`;

export const StyledDutchiePayLogo = styled(DutchiePayLogo)`
  color: ${({ theme }) => theme.colors.dutchiePayGreen};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 28px;
    width: 153px;
  }
`;

export const PayByBankLogo = styled(_PayByBankLogo)`
  color: ${({ theme }) => theme.colors.dutchiePayGreen};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 28px;
    width: 153px;
  }
`;
